'use es6';

export var NEW_LINK_ID = 'new';
export var MEETINGS_APP_NAME = 'meetings';
export var MEETINGS_ADMIN_FEATURE = 'meetings-admin';